import { type FC } from "react";

import { SmartLink } from "../../SmartLink.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import { ENTITY_TYPE } from "@/settings/settings.ts";

const ParentCell: FC<IAgGridCellProps> = (props) => {
  const { value, data, colDef } = props;

  // get rid of the ".stringValue" trailer
  const field: string = colDef.field.substring(0, colDef.field.lastIndexOf("."));
  const id: number = data?.[field]?.[0].parent?.id;

  return (
    <TableCell>
      <SmartLink to={`/${ENTITY_TYPE.SAMPLE_PARENT}/${id}`} tooltip={value}>
        {value}
      </SmartLink>
    </TableCell>
  );
};

export { ParentCell };
export default ParentCell;
